export class ParkMap {
  /* eslint-disable */
  WNAC1_WdDir_mag_f: number;
  fe_name: string;
  lat: number;
  lon: number;
  turbines: any;
  name: string;
  code: string;
  showGoogleEarthIcon: boolean;
  showParkInformationIcon: boolean;
  /* eslint-enable */

  static mapFromPark(park: any) {
    return new ParkMap({
      name: park.name,
      code: park.code,
      WNAC1_WdDir_mag_f: park.data.WNAC1_WdDir_mag_f.avg || park.data.WNAC1_Dir_mag_f.avg,
      fe_name: park.fe_name,
      lat: park.lat,
      lon: park.lon,
      turbines: park.turbines.map(t => ({...t, data: {...t.data, WTUR1_status: t?.data?.WTUR1_status ?? 0}})),
      showGoogleEarthIcon: park.portfolio.name === 'BKW' && !['COQ', 'JUE', 'CAM', 'OEI', 'LII', 'LIII'].includes(park?.code),
      showParkInformationIcon: true
    });
  }

  constructor(init: Partial<ParkMap>) {
    Object.assign(this, init);
  }

}
